import { render, staticRenderFns } from "./ExtinguisherAdd.vue?vue&type=template&id=2d52f8c1&scoped=true&"
import script from "./ExtinguisherAdd.vue?vue&type=script&lang=js&"
export * from "./ExtinguisherAdd.vue?vue&type=script&lang=js&"
import style0 from "./ExtinguisherAdd.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ExtinguisherAdd.vue?vue&type=style&index=1&id=2d52f8c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52f8c1",
  null
  
)

export default component.exports